import { ReactNode } from 'react';
import Button from '../Button';
import styles from './GenericInformationModal.module.scss';

interface Props {
  hideModal: () => void;
  title: string;
  instructions?: string;
  message: string | ReactNode;
}

const ConfirmIrreversible = ({ hideModal, title, message, instructions }: Props): JSX.Element => {
  return (
    <div className={styles.container}>
      <div className={styles.title}>
        <h2>{title}</h2>
        <button onClick={hideModal}>x</button>
      </div>
      <div className={styles.content}>
        <p className={styles.warningMessage}>{message}</p>
        <p className={styles.warningMessage}>{instructions}</p>

        <div className={styles.buttonRow}>
          <Button small onClick={hideModal}>
            OK
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmIrreversible;
